module.exports = __webpack_public_path__ + "img/volunteer_sber_logo.ba76e9df.svg";